export const typographyProps = {
  tag: {
    type: String,
    required: false,
    default: 'p',
  },
  color: {
    type: String,
    required: false,
    default: 'currentColor',
  },
}
